import React, { useState } from 'react';
import { Copy, Share2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import companyStore from '../../store/company-store';
import { useLocation } from 'react-router-dom';
import { slugify } from '../../utils/formatters';

const ShareAvailabilityLink: React.FC = () => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const location = useLocation();
  const langMatch = location.pathname.match(/^\/([a-z]{2})/);
  const currentLang = langMatch ? langMatch[1] : 'fr';

  // Slugifier le domain et businessName pour une URL propre
  const slugifiedDomain = slugify(companyStore.getDefaultCompany?.domain);
  const slugifiedBusinessName = slugify(companyStore.getDefaultCompany?.businessName);
  const shareUrl = `${window.location.origin}/${currentLang}/${slugifiedDomain}/${slugifiedBusinessName}`;


  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: t('availability.shareLink') as string,
          url: shareUrl
        });
      } catch (error) {
        console.error("Share failed:", error);
      }
    } else {
      handleCopyLink();
    }
  };

  return (
    <div className="flex items-center mr-3 w-full sm:w-auto availability-link">
      <h3 className="text-lg font-medium flex items-center gap-2 cursor-pointer" onClick={handleShare}>
        <Share2 className="w-6 h-6 text-primary" />
        {t('availability.shareLink')}
      </h3>
      <button
        className="ml-2 p-2 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
        onClick={handleCopyLink}
        aria-label={t('availability.sharelink') || ''}
      >
        {copied ? (
          <span className="text-primary-light text-sm font-medium">{t('availability.copied')}</span>
        ) : (
          <Copy size={20} className="text-gray-500 dark:text-gray-400" />
        )}
      </button>
    </div>
  );
};

export default ShareAvailabilityLink;
